const ticketUpdateFormDefaults = {
  ticketStatus: 'pending',
  ticketResponseMessage: '',
};

export default ticketUpdateFormDefaults;
